import styles from "components/Form/Form.module.scss";

export const formConfig = {
  id: {
    title: "Configuration ID",
    elementType: "input",
    elementConfig: {
      id: "id",
      type: "text",
      value: "",
      "data-id": "",
      autoComplete: "off",
      placeholder: "Search ID",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: true,
    },
    dropdown: true,
    valid: false,
    touched: false,
    error: {
      message: "ID is required",
    },
  },
  name: {
    title: "Name",
    elementType: "input",
    elementConfig: {
      id: "name",
      type: "text",
      value: "",
      placeholder: "",
      autoComplete: "off",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    },
    valid: false,
    touched: false,
    error: {
      message: "Name is required",
    },
  },
  value: {
    title: "Value",
    elementType: "input",
    elementConfig: {
      id: "value",
      type: "text",
      value: false,
      placeholder: "",
      autoComplete: "off",
    },
    labelClasses: [styles.label],
    elementClasses: [styles.input],
    validation: {
      required: false,
    }, 
    valid: false,
    touched: false,
    error: {
      message: "Value is required",
    },
  },
}